import { initProductListTracking } from './productLists';
import { initPromotionTracking } from './promotions';
import { initFormTracking } from './engagement';

export { trackingMiddleware } from './cart.middleware';
export {
    trackSearch,
    trackFormSubmit,
    trackOrderHistoryView,
    trackReorder,
    trackInvoiceDownload,
} from './engagement';

/**
 * Wires up the tracking that listens to the dom. Everything is guarded so a
 * page without product lists, promotions or forms does nothing at all.
 */
export const initTracking = () => {
    try {
        initProductListTracking();
        initPromotionTracking();
        initFormTracking();
    } catch (e) {
        // Tracking must never break the page.
    }
};
